import React from 'react';
import { calculateErc, ercDue } from '../../../lib/annualOverpayment';

// Helper function for handling negative values
const zeroIfNegative = (value) => Math.max(0, value);

export const CalculatorTable = ({ dataRemainingBalanceTable }) => {
  if (!dataRemainingBalanceTable || dataRemainingBalanceTable.length === 0) {
    return null;
  }

  return (
    <div className="calculator-table-container overflow-x-auto mt-2 rounded-2xl">
      <table className="w-full annual-payment-table border-collapse border border-[#E7E9F0]">
        <thead>
          <tr>
            <th className="bg-[#FFF]"></th>
            <th colSpan="4" className="!bg-[#FFF] text-[#006EB7] text-center font-bold text-2xl border-0 bg-transparent py-2 px-4">
            Balance Remaining
            </th>
            <th colSpan="3" className="!bg-[#FFF] text-[#9b2c78] text-center font-bold text-2xl border-0 bg-transparent py-2 px-4">
            Equity Remaining
            </th>
          </tr>
          <tr>
            <th className="bg-[#FFF] text-center border border-[#E7E9F0] text-sm py-2 px-4">Year</th>
            <th className="bg-[#006EB7] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
              Without An Annual Payment
            </th>
            <th className="bg-[#006EB7] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
              Annual Payment
            </th>
            <th className="bg-[#006EB7] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
              With An Annual Payment
            </th>
            <th className="bg-[#006EB7] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
              Early Repayment Charges
            </th>
            <th className="bg-[#A51367] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
            House Price
            </th>
            <th className="bg-[#A51367] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
            Equity Without A Payment
            </th>
            <th className="bg-[#A51367] text-sm text-center border border-[#E7E9F0] text-white py-2 px-4">
            Equity With A Payment
            </th>
          </tr>
        </thead>
        <tbody>
          {dataRemainingBalanceTable.map((value, index) => {
            const withoutAnnualPayment = zeroIfNegative(Math.round(parseFloat(value.startBNoPay)));
            const withAnnualPayment = zeroIfNegative(Math.round(parseFloat(value.starBal)));
            const housePrice = Math.round(parseFloat(value.ValStart));
            const equityWithoutPayment = housePrice - withoutAnnualPayment;
            // Calculating equity with a payment
            const equityWithPayment = housePrice - withAnnualPayment;
            const ercDue1 = ercDue(value.initialAdvance, value.annualpayment, value.selectedProduct);
            const ercCharge = ercDue1 === true
              ? calculateErc(value.initialAdvance, value.annualpayment, value.selectedProduct, value.year, value.productName)
              : 0;
            const ercRow = zeroIfNegative(Math.round(parseFloat(ercCharge))).toLocaleString();

            return (
              <tr key={index}>
                <th className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">{value.year}</th>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{withoutAnnualPayment.toLocaleString()}</td>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{zeroIfNegative(Math.round(parseFloat(value.annualpayment))).toLocaleString()}</td>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{withAnnualPayment.toLocaleString()}</td>
                <td className={`bg-[#FFF] text-center ${ercRow > 0 ? 'font-bold' : 'font-medium'} text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4`}>£{ercRow}</td>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{housePrice.toLocaleString()}</td>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{equityWithoutPayment.toLocaleString()}</td>
                <td className="bg-[#FFF] text-center font-medium text-[#0C0D1A] text-sm border border-[#E7E9F0] py-2 px-4">£{equityWithPayment.toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
